import React from 'react';

const Footer = () => {
  const footerHTML = `<html>
   <head>
      <style type="text/css">
       html {
           font-family: Nunito, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
           line-height: 1.5;
       }
       * {
           box-sizing: border-box;
           border-width: 0;
           border-style: solid;
           border-color: currentColor;
       }
       .w-full {
           width: 100%;
       }
       .text-white {
           --tw-text-opacity: 1;
           color: rgba(255,255,255,1);
       }
       .bg-black {
           background-color: #121212;
       }
       .relative {
           position: relative;
       }
       .pt-6 {
           padding-top: 1.5rem;
       }
       .mx-auto {
           margin-left: auto;
           margin-right: auto;
       }
       .container {
           width: 100%;
       }
       @media (min-width: 1280px) {
           .container {
               max-width: 1280px;
           }
       }
       @media (min-width: 1024px) {
           .lg\:pl-0 {
               padding-left: 0;
           }
       }
       @media (min-width: 1024px) {
           .lg\:pr-0 {
               padding-right: 0;
           }
       }
       .leading-\[18px\] {
           line-height: 18px;
       }
       .text-center {
           text-align: center;
       }
       .pr-\[25px\] {
           padding-right: 25px;
       }
       .pl-\[25px\] {
           padding-left: 25px;
       }
       .pb-6 {
           padding-bottom: 1.5rem;
       }
       .pt-6 {
           padding-top: 1.5rem;
       }
       .border-opacity-50 {
           --tw-border-opacity: .5;
       }
       .border-t-gray-300 {
           --tw-border-opacity: 1;
           border-top-color: rgba(209, 213, 219, 1);
       }
       .border-t {
           border-top-width: 1px;
       }
       .pr-6 {
           padding-right: 1.5rem;
       }
       .pl-6 {
           padding-left: 1.5rem;
       }
       .pb-6 {
           padding-bottom: 1.5rem;
       }
       .pt-6 {
           padding-top: 1.5rem;
       }
       .flex-wrap {
           flex-wrap: wrap;
       }
       .flex {
           display: flex;
       }
       @media (min-width: 1024px) {
           .lg\:w-1\/2 {
               width: 50%
           }
       }
       .mt-6 {
           margin-top: 1.5rem;
       }
       .mb-6 {
           margin-bottom: 1.5rem;
       }
       img, video {
           max-width: 100%;
           height: auto;
       }
       img, svg, video, canvas, audio, iframe, embed, object {
           display: block;
           vertical-align: middle;
       }
       img {
           border-style: solid;
       }
       @media (min-width: 1280px) {
           .xl\:pr-0 {
               padding-right: 0;
           }
       }
       @media (min-width: 1024px) {
           .lg\:pr-4 {
               padding-right: 1rem;
           }
       }
       @media (min-width: 768px) {
           .md\:mb-0 {
               margin-bottom: 0;
           }
       }
       .max-w-screen-sm {
           max-width: 640px;
       }
       .mb-8 {
           margin-bottom: 2rem;
       }
       @media (min-width: 1024px) {
           .lg\:pl-12 {
               padding-left: 3rem;
           }
       }
       @media (min-width: 768px) {
           .md\:mt-6 {
               margin-top: 1.5rem;
           }
       }
       .flex-wrap {
           flex-wrap: wrap;
       }
       .flex {
           display: flex
           ;
       }
       @media (min-width: 768px) {
           .md\:w-1\/3 {
               width: 33.333333%;
           }
       }
       @media (min-width: 768px) {
           .md\:mb-0 {
               margin-bottom: 0;
           }
       }
       .mb-8 {
           margin-bottom: 2rem;
       }
       .mb-3 {
           margin-bottom: .75rem;
       }
       .text-lg {
           font-size: 1.125rem;
           line-height: 1.75rem;
       }
       ol, ul {
           list-style: none;
           margin: 0;
           padding: 0;
       }
       .mb-3 {
           margin-bottom: .75rem;
           color: white
       }
       a, button {
           outline: 2px solid transparent;
           outline-offset: 2px;
       }
       a {
           color: inherit;
           text-decoration: inherit;
       }
   </style>
   </head>
   <body>
      <footer class="bg-black pt-6 relative text-white">
         <div class="container mx-auto">
  <div class="container mx-auto">
  <div class="flex flex-wrap pt-6 pb-6">
    <!-- Left Section -->
    <div class="w-1/2 pr-12" style="padding: 12px">
      <div class="mb-6 mt-6">
        <img src="https://cdn.newswav.com/img/web-revamp/white-logo.png" alt="Newswav Malaysia Best News App" width="110" height="17">
      </div>
      <div class="lg:pr-4 xl:pr-0 max-w-screen-sm mb-8">
        Newswav is an online content aggregator and obtains its content from different online sources. The content in the app do not belong to Newswav nor do they reflect the opinions of Newswav and its staff. Your use of this app indicates your understanding and acceptance of this information.
      </div>
    </div>

    <div style="width: 40px;"></div>

    <!-- Right Section -->
    <div class="w-1/2 flex space-x-8">
    <div style="width: 10px;"></div>
    <!-- Company Column -->
    <div class="w-1/3">
        <div class="mb-3">
        <strong class="text-lg">Company</strong>
        </div>
        <ul class="footer-nav-links">
        <li class="mb-3">
            <a href="https://creator.newswav.com" target="_blank" rel="noopener noreferrer">Creator</a>
        </li>
        <li class="mb-3">
            <a href="https://newswav.com/terms" target="_self" rel="noopener noreferrer">Terms of Use</a>
        </li>
        <li class="mb-3">
            <a href="https://newswav.com/privacy" target="_self" rel="noopener noreferrer">Privacy Policy</a>
        </li>
        <li class="mb-3">
            <a href="https://newswav.com/careers" target="_blank" rel="noopener noreferrer">Careers</a>
        </li>
        </ul>
    </div>

    <!-- Spacer/Divider -->
    <div style="width: 100px;"></div>

    <!-- Contact Column -->
    <div class="w-1/3">
        <div class="mb-3">
        <strong class="text-lg">Contact</strong>
        </div>
        <ul class="footer-nav-links">
        <li class="mb-3">
            <a href="mailto:hello@newswav.com" target="_blank" rel="noopener noreferrer">Email</a>
        </li>
        <li class="mb-3">
            <a href="https://www.facebook.com/newswav" target="_blank" rel="noopener noreferrer">Facebook</a>
        </li>
        <li class="mb-3">
            <a href="https://www.instagram.com/newswavapp/" target="_blank" rel="noopener noreferrer">Instagram</a>
        </li>
        <li class="mb-3">
            <a href="https://twitter.com/newswav" target="_blank" rel="noopener noreferrer">Twitter</a>
        </li>
        </ul>
    </div>

    <!-- Spacer/Divider -->
    <div style="width: 100px;"></div>

    <!-- Download Column -->
    <div class="w-1/3">
        <div class="mb-3">
        <strong class="text-lg">Download</strong>
        </div>
        <ul class="footer-nav-links">
        <li class="mb-3">
            <a href="https://itunes.apple.com/my/app/id1222559123?mt=8" target="_blank" rel="noopener noreferrer">iOS</a>
        </li>
        <li class="mb-3">
            <a href="https://play.google.com/store/apps/details?id=com.newswav.android" target="_blank" rel="noopener noreferrer">Android</a>
        </li>
        <li class="mb-3">
            <a href="https://appgallery.cloud.huawei.com/marketshare/app/C100936177?locale=en_GB" target="_blank" rel="noopener noreferrer">Huawei</a>
        </li>
        </ul>
    </div>
    </div>

  </div>
</div>


         <div class="text-center pt-6 pb-6 leading-[18px] pl-[25px] pr-[25px] lg:pr-0 lg:pl-0 border-t border-t-gray-300 border-opacity-50"> Newswav Sdn. Bhd. (201701008480 (1222645-M)) 2025 All Rights Reserved </div>
      </footer>
   </body>
</html>`;

  return (
    <div
      dangerouslySetInnerHTML={{ __html: footerHTML }}
    />
  );
};

export default Footer;
